export const formatIeComplaintDateTime = (value) => {
  if (!value) return "N/A";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const formatIeComplaintCreatedOn = (value) => {
  if (!value) return "N/A";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const time = date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return `${day}-${month}-${year} ${time}`;
};

export const parseIeComplaintCoordinate = (...values) => {
  for (const value of values) {
    if (value === undefined || value === null || value === "") continue;
    const parsed = typeof value === "string" ? parseFloat(value) : Number(value);
    if (!Number.isNaN(parsed)) return parsed;
  }
  return null;
};

export const getIeComplaintCloseTimePosition = (row) => {
  const lat = parseIeComplaintCoordinate(
    row?.closeTimeLatitude,
    row?.cLat,
    row?.latitude,
    row?.fLat
  );
  const lng = parseIeComplaintCoordinate(
    row?.closeTimeLongitude,
    row?.cLng,
    row?.longitude,
    row?.fLng
  );

  if (lat === null || lng === null) return null;
  return { lat, lng };
};

export const ieComplaintOptions = {
  modeOfReportingOptions: ["Mobile App", "Call Center", "Web Portal", "APP", "WEB"],
};
